import React from 'react';
import Loader from 'react-simple-loading';


function FullLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader color="white" />
    </div>);
}

export default FullLoader;
